/**
 * @version 1.0.1
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *  2023-04-02 (1.0.1) (jhoward)
 *	    - Refactor get-selected-filters.js to get-selected-filters.ts.
 */

import {StateFilter} from "../store/hotel-rooms";

export interface SelectedFilterOutput {
    [key: string]: string[]
}

export function getSelectedFilters (filters: StateFilter[]): SelectedFilterOutput {
    let selectedFilters: SelectedFilterOutput = {};
    filters.forEach(filter => {
        selectedFilters[filter.key] = [];
        filter.items.forEach(filterValue => {
            if (filterValue.selected) {
                selectedFilters[filter.key].push(filterValue.value);
            }
        });
    });

    return selectedFilters;
}